<template>
    <div class="graph-panel">
        <div>
           <h2>{{ title }}</h2>
        </div>
        <!--
        <div id="comp-syn-div">
            <input type="checkbox" id="synapse-cb" v-model="synapse">
            <label for="synapse-cb" class="syn-label">Show Synaptic Connections</label>
        </div>
        
        <div v-if="synapse" v-html="synapseSvgGraph"></div>
        -->
        <div class="d-flex justify-content-between">
            <div class="align-items: center">
                <input type="checkbox" id="layout-cb" v-model="layoutButChecked" @change="prepGraph"/>
                <label for="layout-cb" class="layout-label">Left to Right</label>
            </div>
        </div>
        <div v-html="svgLegend"></div>
        <div v-html="svgGraph"></div>
    </div>
</template>
<script>
import { instance } from "@viz-js/viz";

export default {
    props: ["compositeDg", "compositeSynapseDg","title"],
    data() {
        return {
            svgGraph: "",
            svgLegend: "",
            synapseSvgGraph: "",
            synapse: false,
            layoutButChecked: false
        };
    },
    methods: {
        getVizLegend() {
            const legend = `digraph G 
                    {   
                        subgraph cluster_legend 
                        {
                            rankdir=LR; // Left-to-right layout for the legend
                            label = "Legend";
                            fontsize = 12;
                            shape = "rect";
                            style = "rounded, dotted"; // Dashed box around the legend
                            legend_synapse [label="Synapse\nLocation", fontsize=12, shape=rect, style="rounded, filled", fillcolor="#eefaec", peripheries=2, color=black];
                            legend_axon_sensory_terminal [label="Sensory\nTerminal", fontsize=12, shape=rect, color=red];
                            legend_axon_terminal [label="Axon\nTerminal", fontsize=12, shape=rect, style="rounded, diagonals, filled", fillcolor="#feeeee", color=red];
                            legend_axon [label="Axon\nLocation", fontsize=12, shape=rect, style="rounded, filled, dashed", fillcolor="#ecf1fe" color=black];
                            legend_soma [label="Soma\nLocation", fontsize=12, shape=rect, style="rounded, filled", fillcolor="#eefaec", color=black];
                        }
                    }`
            return legend;
        },
        prepGraph() {
            if (this.compositeDg !== '') {
                instance().then((viz) => {
                    // console.log("in prepGraph");
                    const layout = this.layoutButChecked ? 'LR' : 'TB';
                    let graphDef = this.compositeDg.replace(/rankdir\s*=\s*[A-Z]+\s*;?\s*/gi, '');
                    graphDef = graphDef.replace(/(strict\s+)?digraph(\s+\w+)?\s*\{/, (match) => {
                        return match + '\nrankdir=' + layout + ';';
                    });
                    this.svgGraph = viz.renderString(graphDef, { format: "svg" });
                    // console.log("svgGraph:" + this.svgGraph); 
                    // this.synapseSvgGraph = viz.renderString(this.compositeSynapseDg, {format: "svg"});
                    const legend = this.getVizLegend();
                    this.svgLegend = viz.renderString(legend, { format: "svg" });
                });
            }
        }
    },
    mounted() {
        this.prepGraph();
    },   
};

</script>

<style scoped>
.graph-panel {
    /* border: 1px solid black; */
    margin: 3px;
}

#layout-cb {
    width: 25px;
    height: 25px;
    vertical-align: middle;
}

.layout-label {
    background-color: #FBE0C0;
    color: black;
    padding: 5px 5px;
    cursor: pointer;
    margin-left: 3px;
    vertical-align: middle;
}


#comp-syn-div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px auto 20px auto;
    width: fit-content;
}

#synapse-cb {
    width: 25px;
    height: 25px;
    vertical-align: middle;
}

.syn-label {
    background-color: #C0F0FB;
    color: black;
    padding: 5px 5px;
    cursor: pointer;
    margin-left: 3px;
    vertical-align: middle;
}
</style>